<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="intro-content box text-center">
            <h2 style="color:black">Error!</h2>
            <p style="color:black">An error has occcured with your payment.</p>
            <p style="color:black">Error: {{ payment[0].paymentStatus }}</p>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      :autoHeight="true"
      id="intro-carousel"
      style="margin-top:-50px;"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img class="item" src="/img/intro-carousel/home-1.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/16.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/comm-1.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/comm-4.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/3.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/home-5.jpg" alt="" />
    </carousel>
  </section>
</template>

<script>
/* eslint-disable */
import carousel from "vue-owl-carousel";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    carousel
  },
  data() {
    return {
      boolLoaded: false
    };
  },
  created() {
    this.getPayment(this.$route.params.id);
  },
  computed: {
    ...mapState("payment", ["payment"])
  },
  methods: {
    ...mapActions("payment", ["getPayment"])
  }
};
</script>

<style lang="scss" scoped>
.box {
  background-color: rgba(255, 67, 67, 0.6) !important;
}
</style>
